import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {
    EnableDisableChildrenAIGuide,
    EnableDisableChildrenAIGuideVariables,
} from "./__graphql-types__/EnableDisableChildrenAIGuide.ts";

export const ENABLE_DISABLE_CHILDREN_AI_GUIDE_MUTATION: GqlOperation<
    EnableDisableChildrenAIGuide,
    EnableDisableChildrenAIGuideVariables
> = gqlOp(gql`
    mutation EnableDisableChildrenAIGuide(
        $enableKAIDs: [String!]!
        $disableKAIDs: [String!]!
    ) {
        aiGuideDeactivateChildAccounts(childKAIDs: $disableKAIDs) {
            errors {
                code
                debugMessage
                kaid
            }
        }
        aiGuideActivateChildAccounts(childKAIDs: $enableKAIDs) {
            errors {
                code
                debugMessage
                kaid
            }
        }
    }
`);
